import { getApv, postApv } from '../../apis';
import { getIframe, setAddEventListener, setNumericOnly } from '../../helpers';
import { serialize } from '../../helpers';
import { pushRouter, routes } from '../../router';
import { setDisableBackControl } from '../../utils/back-control';
import { amtFormatter, removeComma } from '../../utils/common';
import { setAlertModal, showAlertModal } from '../components/alert';

const ChargRemitcUid = {
  render: async () => {
    return `<div>
                <a class="c_back" id="connect_pay_back_button"></a>
            </div>
            <div class="c_title1">충전머니 송금 (머니to머니)</div>
            <div class="form-group m_b_20">
              <label class="c_label1">충전머니 잔액 (송금 가능금액)</label>
              <input type="text" id="chrg_bal" class="form-control c_input1 skin1_input" disabled />
            </div>
            <div class="form-group m_b_20">
                <label class="c_label1">받는사람 (UID)</label>
                <input type="text" class="form-control c_input1 skin1_input" id="uid" placeholder="UID">
            </div>
            <div class="form-group m_b_20">
                <label class="c_label1">보낼금액</label>
                <input type="text" class="form-control c_input1 skin1_input" id="out_amt" placeholder="보낼금액" pattern="[0-9]*" inputmode="numeric">
            </div>
            <div class="m_t_10">
                <span class="c_label5_1">
                - 머니to머니 송금을 테스트하기 위한 샘플 화면입니다.<br/>
                </span>
            </div>
            <div class="bottom_btn_wrapper">
                <button class="btn c_btn1 skin1_btn" data-toggle="modal" data-target="#charg_confirm" id="remitc_commit">확인</button>
            </div>`;
  },
  afterRender: async () => {
    let moneyBalance = 0;

    setNumericOnly('out_amt');

    try {
      // 충전머니 잔액조회
      const meneyBalanceResult = await getApv('charging/moneyBalance');
      moneyBalance = meneyBalanceResult?.chrgBal ?? 0;
    } catch (e) {
      showAlertModal('오류', e.resultMessage);
      console.error(e.resultMessage);
    } finally {
      //잔액 세팅
      getIframe().getElementById('chrg_bal').value = amtFormatter(moneyBalance);
    }

    const onClickCommit = async () => {
      if (getIframe().getElementById('uid').value.trim() == '') {
        showAlertModal('충전머니 송금', '받는사람(UID)를 입력해주세요.');
        return;
      }
      if (getIframe().getElementById('out_amt').value.trim() == '') {
        showAlertModal('충전머니 송금', '보낼금액을 입력해주세요.');
        return;
      }
      if (
        Number(
          removeComma(getIframe().getElementById('chrg_bal').value)
            .replace('원', '')
            .trim()
        ) < Number(getIframe().getElementById('out_amt').value.trim())
      ) {
        showAlertModal('충전머니 송금', '충전머니 잔액이 부족합니다.');
        return;
      }

      const brandInfo = JSON.parse(sessionStorage.getItem('CONPAY_BRAND_INFO'));
      const uid = getIframe().getElementById('uid').value;
      const outAmt = getIframe().getElementById('out_amt').value;

      const execTransfer = async (tranData) => {
        const res = await postApv('charging/rsvd/transfer', tranData);

        // 완료페이지에서 사용할 데이터
        // sessionStorage.setItem('CONPAY_COMPLETE_INFO', serialize(tranData));

        sessionStorage.setItem(
          'CONPAY_COMPLETE_INFO',
          serialize({
            ...tranData,
            ...res,
          })
        );

        // pin 확인 -> 완료페이지
        pushRouter(
          {
            mode: 'PIN_CHECK',
            nextHash: routes.remitcComplete.hashPath,
            nextState: {
              refererHash: routes.chargRemitcUid.hashPath,
              // rsvdUrl: 'charging/rsvd/transfer',
              // aprvUrl: history.state.aprvUrl,
              // uid,
              // outAmt,
            },
          },
          null,
          routes.enterPwd.hashPath,
          () => {
            setDisableBackControl();
          }
        );
      };

      try {
        const msg = `받는사람(UID): ${uid}
       보낼금액: ${amtFormatter(outAmt)}원
        `;

        const tranData = {
          trDiv: '3201',
          outAmt,
          tgtUid: brandInfo.bid + uid,
        };
        showAlertModal('알림', msg, () => execTransfer(tranData));
      } catch (e) {
        showAlertModal('오류', e.resultMessage);
        console.error(e.resultMessage);
      }
    };

    // setView
    setAlertModal();

    // setEvent
    setAddEventListener('connect_pay_back_button', () => history.back());
    setAddEventListener('remitc_commit', onClickCommit);
  },
};
export default ChargRemitcUid;
